import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
    SupplierActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError
} from '@actions/supplier'
import supplierApi from '@api/supplier'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(supplierApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}

function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(supplierApi.delete, payload);
    yield put(deleteSuccess(payload));
  } catch (err) {
    yield put(deleteError(err))
  }
}

function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(supplierApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data));
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(supplierApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* supplierSaga() {
  yield all([
    yield takeEvery(SupplierActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(SupplierActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(SupplierActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(SupplierActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default supplierSaga
